import {
  Directive,
  HostBinding,
  Signal,
  computed,
  inject,
  input,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { UaParserService } from '@pinup-teams/common';
import { environment } from '@fb/environments';

export enum SlackLinkType {
  Channel = 'channel',
  User = 'user',
}

const SLACK_TEAM_ID = environment.slackTeamId;

@Directive({
  selector: '[puSlackLink]',
  standalone: true,
})
export class SlackLinkDirective {
  #uaParserService = inject(UaParserService);
  #sanitizer = inject(DomSanitizer);

  slackId = input.required<string>({ alias: 'puSlackLink' });
  linkType = input<SlackLinkType>(SlackLinkType.User);

  safeSlackLink: Signal<SafeResourceUrl> = computed(() => {
    const slackLink = this.#uaParserService.isDesktop
      ? `https://slack.com/app_redirect?channel=${this.slackId()}&team=${SLACK_TEAM_ID}`
      : `slack://${this.linkType()}?team=${SLACK_TEAM_ID}&id=${this.slackId()}`;

    return this.#sanitizer.bypassSecurityTrustResourceUrl(slackLink);
  });

  @HostBinding('attr.href') get href() {
    return this.safeSlackLink();
  }
}
